export default __webpack_public_path__ + "static/media/delete.7d2a22fc.svg";